import { add, endOfMonth, format } from 'date-fns';
import { useState } from 'react';

import mboApi from 'infrastructure/redux/adapters/mboAPI/mboApi';

interface UseStaffAvailableDatesClubFittingsParams {
  staffId: number;
  locationId: string;
}

const useStaffAvailableDatesClubFittings = ({
  staffId,
  locationId,
}: UseStaffAvailableDatesClubFittingsParams) => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(endOfMonth(add(new Date(), { months: 1 })));

  const handleFetchFurtherAvailableDates = (newDate: Date | null) => {
    if (newDate) {
      setEndDate(endOfMonth(add(newDate, { months: 1 })));
    }
  };

  const {
    data: staffAvailableFittingDates,
    isLoading: arestaffAvailableFittingDatesLoading,
    error: staffAvailableFittingDatesError,
    isFetching: arestaffAvailableFittingDatesFetching,
  } = mboApi.useGetAvailableFittingDatesQuery(
    {
      staffId,
      locationId,
      startDateTime: format(startDate, 'yyyy-MM-dd'),
      endDateTime: format(endDate, 'yyyy-MM-dd'),
    },
    {
      skip: !locationId,
      refetchOnMountOrArgChange: true,
    },
  );

  return {
    staffAvailableFittingDates,
    arestaffAvailableFittingDatesLoading,
    staffAvailableFittingDatesError,
    arestaffAvailableFittingDatesFetching,
    setstaffAvailableFittingDatesStartDate: (value: Date) => setStartDate(value),
    setstaffAvailableFittingDatesEndDate: (value: Date) => setEndDate(value),
    fetchFurtherAvailableDates: handleFetchFurtherAvailableDates,
  };
};

export default useStaffAvailableDatesClubFittings;
